// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.article-modal-panel {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.article-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 1.8rem;
  border-bottom: 1px solid #e5e7eb;
}

.article-modal-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.article-modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.article-modal-close:hover {
  color: #374151;
}

.article-modal-body {
  overflow-y: auto;
  padding: 1.4rem 1.8rem;
}

.article-modal-description {
  font-size: 1.3rem;
  color: #374151;
  line-height: 1.7;
  margin: 0;
  white-space: pre-wrap;
}

.article-modal-empty {
  font-size: 1.3rem;
  color: #9ca3af;
  font-style: italic;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/ArticleDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".article-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n}\n\n.article-modal-panel {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.article-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.4rem 1.8rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.article-modal-title {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.article-modal-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n}\n\n.article-modal-close:hover {\n  color: #374151;\n}\n\n.article-modal-body {\n  overflow-y: auto;\n  padding: 1.4rem 1.8rem;\n}\n\n.article-modal-description {\n  font-size: 1.3rem;\n  color: #374151;\n  line-height: 1.7;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.article-modal-empty {\n  font-size: 1.3rem;\n  color: #9ca3af;\n  font-style: italic;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
